import { transformProduct } from "@/utils/transform";
import { Product } from "@~/types/types";
import { PageProps } from "@/getServerSideProps/getServerSideProps";

function getProductUrl(product: Product) {
  return product.variants.filter(
    (variant) => variant.id === product.defaultVariant.id,
  )[0]?.pdpURL.url;
}

export function StructuredData({
  productListingData,
}: Pick<PageProps, "productListingData">) {
  const products = productListingData.products.map((product) =>
    transformProduct(product),
  );

  const structuredData = {
    "@type": "ItemList",
    "@context": "https://schema.org",
    numberOfItems: `(${products.length})`,
    itemListElement: products.map((product, i) => ({
      "@type": "ListItem",
      url: `https://www.johnlewis.com${getProductUrl(product)}`,
      position: i + 1,
    })),
  };

  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
}
